import React from "react";
import { Switch, Route, useRouteMatch } from "react-router-dom";

import DecoMethodsAddEdit from "./DecoMethodsAddEdit";
import DecoMethodsTable from "./DecoMethodsTable";

function DecoMethodsTableContainer(props) {
  const { path } = useRouteMatch();

  return (
    <>
      <Switch>
        <Route exact path={`${path}/edit/:id`}>
          <DecoMethodsAddEdit />
        </Route>
        <Route exact path={`${path}/add`}>
          <DecoMethodsAddEdit />
        </Route>
        <Route path={`${path}`}>
          <DecoMethodsTable />
        </Route>
      </Switch>
    </>
  );
}

export default DecoMethodsTableContainer;
